export interface TestEvents {
  synchronized: boolean
  events: TestEvent[]
}

export const EventType = {
  SIMPLE_REACTION: 'simpleReaction',
  DISCRIMINATION_REACTION: 'discriminationReaction',
  HARDWARE_TEST: 'hardwareTest',
} as const

export type EventTypeValue = (typeof EventType)[keyof typeof EventType]

export interface TestEvent {
  type: EventTypeValue
  date: Date
  synchronized: boolean
}

export interface SimpleReactionTestEvent extends TestEvent {
  type: typeof EventType.SIMPLE_REACTION
  date: Date
  synchronized: boolean
  median: number
  failures: number
}

export interface DiscriminationReactionTestEvent extends TestEvent {
  type: typeof EventType.DISCRIMINATION_REACTION
  date: Date
  synchronized: boolean
  median: number
  min: number
  max: number
  failures: number
  earlyFailures?: number | undefined
  falseAlarmFailures?: number | undefined
  difficulty: 'easy' | 'medium' | 'hard'
}

export const DEFAULT_TEST_EVENTS: TestEvents = {
  synchronized: false,
  events: [],
}

export const EVENT_TYPES = [
  { label: 'Einfachreaktion', value: EventType.SIMPLE_REACTION },
  { label: 'Unterscheidungsreaktion', value: EventType.DISCRIMINATION_REACTION },
  { label: 'Hardware-Test', value: EventType.HARDWARE_TEST },
] as const
